import {differenceInCalendarDays} from 'date-fns';

export const getDaysPast = (date: Date | string): number => {
  if (typeof date === 'string')
    return differenceInCalendarDays(Date.now(), Date.parse(date));
  return differenceInCalendarDays(Date.now(), date);
};
